import LoginView from "./LoginView";

export default LoginView;